var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn",attrs:{"pill":"","size":"lg"},on:{"click":_vm.logoClick}},[_vm._v("Ping pong")])}
var staticRenderFns = []

export { render, staticRenderFns }